import React from "react";
import BrandedActionButton, {
  type BrandedActionButtonProps,
} from "src/components/branded-action-button";
import { FooterWithChildren } from "@repo/ui/FooterWithChildren";
import classNames from "classnames";

interface KinsaButtonFooterProps extends Omit<BrandedActionButtonProps, "text"> {
  buttonText: string;
  containerClassName?: string;
  children?: React.ReactNode;
}

const KinsaButtonFooter: React.FC<KinsaButtonFooterProps> = ({
  buttonText,
  containerClassName,
  children,
  ...rest
}) => {
  return (
    <FooterWithChildren
      className={classNames(
        containerClassName,
        "px-[16px] pt-[16px] pb-[calc(var(--felt-safe-area-bottom)+16px)]"
      )}
    >
      {children}
      <BrandedActionButton text={buttonText} {...rest} />
    </FooterWithChildren>
  );
};

export default KinsaButtonFooter;
